import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import { useTranslation } from "react-i18next";
import Img from "../../src/images/noticeImg1.jpg";
import Img2 from "../../src/images/noticeImg2.webp";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DocumentScannerRoundedIcon from "@mui/icons-material/DocumentScannerRounded";
import pdfUrl from "../../src/docs/samplePDF.pdf";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import Tooltip from "@mui/material/Tooltip";
import { TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { show_all_notice_api } from "../api/Users";
import { TablePagination } from "@mui/material";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";

const SampleNotice = ({ role, userData }) => {
  const { t } = useTranslation();
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");

  const iframeRef = React.useRef(null);
  const [noticeData, setNoticeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [category, setCategory] = useState("all");

  const handleFullscreen = () => {
    if (iframeRef.current) {
      const iframeDocument =
        iframeRef.current.contentDocument ||
        iframeRef.current.contentWindow.document;
      if (iframeDocument.fullscreenElement) {
        document.exitFullscreen();
      } else {
        if (iframeRef.current.requestFullscreen) {
          iframeRef.current.requestFullscreen().catch((err) => {
            console.error(
              `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
            );
          });
        } else if (iframeRef.current.webkitRequestFullscreen) {
          iframeRef.current.webkitRequestFullscreen();
        }
      }
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleImageClick = (imageData) => {
    var w = window.open("about:blank");
    setTimeout(() => {
      w.document.body.appendChild(w.document.createElement("iframe")).src =
        "data:image/png;base64," + imageData;
      w.document.body.style.margin = 0;
      w.document.getElementsByTagName("iframe")[0].style.width = "100%";
      w.document.getElementsByTagName("iframe")[0].style.height = "100%";
      w.document.getElementsByTagName("iframe")[0].style.border = 0;
    }, 0);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeModal1 = () => {
    setIsModalOpen1(false);
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const handleSearch = () => {
    setIsLoading(true);

    const data = {
      category: category,
    };

    show_all_notice_api(data)
      .then((response) => {
        if (response.status === "success") {
          setIsLoading(false);
          setNoticeData(response.data.result);
        } else {
          setIsLoading(false);
          setNoticeData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching notices:", error);
      });
  };

  function openPDFInNewTab(base64String) {
    const decodedData = window.atob(base64String);
    const uint8Array = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      uint8Array[i] = decodedData.charCodeAt(i);
    }
    const blob = new Blob([uint8Array], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  }

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="my-4">{t("View All Notices")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                display: "flex",
                marginLeft: "3rem",
                width: "17rem",
                border: "",
                borderRadius: "35px",
                marginTop: "20px",
              }}
            />
          </div>
        </div>

        <div className="my-3 col-12 d-flex justify-content-start align-items-center">
          <div className="col-md-2">
            <label className="form-label">
              {t("Category")} {<span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="category"
              className="common-input form-select"
              onChange={(e) => setCategory(e.target.value)}
              required
            >
              <option value="all">All</option>
              <option value="Suggestion">Suggestion</option>
              <option value="Achievement">Achievement</option>
            </select>
          </div>
          <div className="col-md-4">
            <button
              className="btn btn-primary btn-sm mx-5"
              style={{ marginTop: "35px", height: "30px" }}
              onClick={handleSearch}
            >
              {t("Search")}
            </button>
          </div>
        </div>
      </div>
      <div className="noticeBoard mt-2" style={{ marginLeft: "7em" }}>
        <div className="noticeBody">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4 mx-1rem"
          >
            <Table sx={{ minWidth: 700 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">{t("Sr. No.")}</TableCell>
                  <TableCell align="left">{t("NOTICE")}</TableCell>
                  <TableCell align="left">{t("CATEGORY")}</TableCell>
                  <TableCell align="left">{t("ISSUE DATE")}</TableCell>
                  <TableCell align="left">{t("IMAGES")}</TableCell>
                  <TableCell align="left">{t("DOCUMENTS")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && (
                <>
                  {noticeData && noticeData.length > 0 ? (
                    <TableBody style={{ color: "white" }}>
                      {noticeData
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                          <TableRow key={index}>
                            <TableCell
                              component="th"
                              scope="row"
                              align="center"
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {row.notice_text}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {row.category}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {row.start_date}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {row.notice_photo_base64 && (
                                <img
                                  src={`data:image/png;base64,${row.notice_photo_base64}`}
                                  className="border border-3"
                                  alt="Notice"
                                  style={{
                                    width: "50px",
                                    borderRadius: "50%",
                                    height: "50px",
                                  }}
                                  onClick={() =>
                                    handleImageClick(row.notice_photo_base64)
                                  }
                                />
                              )}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ borderBottom: "0" }}
                            >
                              <ListItemAvatar
                                style={{ display: "flex", marginLeft: "2rem" }}
                              >
                                <Avatar>
                                  <DocumentScannerRoundedIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      openPDFInNewTab(row.attachment_base64)
                                    }
                                  />
                                </Avatar>
                              </ListItemAvatar>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={7}>
                          <h4>
                            <i>{t("No data available")}</i>
                          </h4>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={noticeData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>

        <Modal
          open={isModalOpen}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: "fitContent",
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Image(s).
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <img src={Img} alt="" style={{ height: "15rem" }} />
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <img src={Img2} alt="" style={{ height: "15rem" }} />
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button color="secondary" onClick={closeModal}>
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
        <Modal
          open={isModalOpen1}
          onClose={closeModal1}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: "70rem",
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
              overflow: "auto",
            }}
          >
            <IconButton
              aria-label="close"
              onClick={closeModal1}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "black",
              }}
            >
              <CloseIcon />
            </IconButton>
            <Tooltip title="Full Screen">
              <IconButton
                aria-label="fullscreen"
                onClick={handleFullscreen}
                sx={{
                  position: "absolute",
                  right: 48,
                  top: 8,
                  color: "black",
                }}
              >
                <FullscreenIcon />
              </IconButton>
            </Tooltip>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Cyber Security Webinar
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
            ></Typography>
            <iframe
              ref={iframeRef}
              allow="fullscreen"
              src={pdfUrl}
              width="100%"
              height="400px"
            />
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button color="secondary" onClick={closeModal1}>
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default SampleNotice;
